import { BaseContainerModel } from '../base-container.model';
import { bl_cms_website_user_agreement_document_hdr_RowClass } from '../../dbschema';

export class UserAgreementDocumentContainerModel extends BaseContainerModel {
    bl_cms_website_user_agreement_document_hdr: bl_cms_website_user_agreement_document_hdr_RowClass = new bl_cms_website_user_agreement_document_hdr_RowClass();
}
